<!--
 * @Descripttion: 关于页面组件
 * @Author: congz
 * @Date: 2020-07-11 19:29:46
 * @LastEditors: congz
 * @LastEditTime: 2020-08-04 11:20:44
--> 


<template>
  <div class="about" id="about" name="about">
    <!-- About Header -->
    <div class="about-header">
      <div class="about-header-bg"></div>
      <div class="about-header-content">
        <h1>About NovaShop</h1>
        <p>Elegance in every thread, tradition in every fold</p>
      </div>
    </div>

    <!-- About Navigation -->
    <div class="about-nav">
      <div class="about-nav-inner">
        <router-link to="/about?id=1" :class="{active: nid===1}">Our Story</router-link>
        <router-link to="/about?id=2" :class="{active: nid===2}">Privacy Policy</router-link>
        <router-link to="/about?id=3" :class="{active: nid===3}">Shipping & Delivery</router-link>
        <router-link to="/about?id=4" :class="{active: nid===4}">Returns & Exchanges</router-link>
        <router-link to="/about?id=6" :class="{active: nid===6}">Terms of Service</router-link>
      </div>
    </div>

    <!-- About Content -->
    <div class="about-layout">
      <div class="about-content">
        <MyMarkdown :nid="nid"></MyMarkdown>
      </div>
    </div>
  </div>
</template>
<script>
import MyMarkdown from '../components/MyMarkdown'
export default {
  name: 'About',
  activated() {
    if (this.$route.query.id !== undefined) {
      this.nid = this.$route.query.id*1
    } else {
      this.nid = 1 // Default to Our Story
    }
  },
  watch: {
    $route: function(val) {
      if (val.path == '/about') {
        if (val.query.id !== undefined) {
          this.nid = val.query.id * 1
        } else {
          this.nid = 1
        }
      }
    }
  },
  data() {
    return {
      nid: this.$route.query.id !== undefined ? this.$route.query.id * 1 : 1,
    }
  },
  components: {
    MyMarkdown
  }
}
</script>
<style scoped>
.about {
  background-color: #EFF6FF;
  min-height: 100vh;
}

/* About Header */
.about-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.about-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #4338CA 0%, #3730A3 50%, #818CF8 100%);
}
.about-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.about-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.about-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.about-header-content p {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
  font-style: italic;
}

/* About Navigation */
.about-nav {
  background: #ffffff;
  border-bottom: 1px solid #E8D4D4;
  position: sticky;
  top: 0;
  z-index: 10;
}
.about-nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 8px;
  padding: 0 24px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.about-nav-inner::-webkit-scrollbar {
  display: none;
}
.about-nav a {
  flex-shrink: 0;
  padding: 16px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #666666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
  white-space: nowrap;
}
.about-nav a:hover {
  color: #4338CA;
}
.about-nav a.active {
  color: #4338CA;
  border-bottom-color: #4338CA;
}

/* About Layout */
.about-layout {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}
.about-content {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 18px 40px rgba(185, 54, 91, 0.06);
}

/* Responsive */
@media (max-width: 900px) {
  .about-header {
    height: 200px;
  }
  .about-header-content h1 {
    font-size: 28px;
  }
  .about-header-content p {
    font-size: 14px;
  }
  .about-nav-inner {
    padding: 0 12px;
  }
  .about-nav a {
    padding: 14px 12px;
    font-size: 11px;
  }
  .about-layout {
    padding: 20px 12px 60px;
  }
  .about-content {
    padding: 24px;
    border-radius: 12px;
  }
}
</style>